import { HubConnectionState } from './hub-connection-state';
import { createSelector, select, Store } from '@ngrx/store';
import { distinctUntilChanged, filter, first, Observable, timeout } from 'rxjs';
import { AppState, SignalRData } from '../lemans-app.model';
const stateSelector = (state: AppState): SignalRData => state.signalR;
export const selectSignalRState = createSelector(stateSelector, (state: SignalRData) => state);
export const selectDomainMessage = createSelector(selectSignalRState, (state: SignalRData) => state.domainMessage);
export const selectConnectionState = createSelector(selectSignalRState, (state: SignalRData) => state.connectionState);
export const selectLastError = createSelector(selectSignalRState, (state: SignalRData) => state.lastError);

// we need selectors with filters applied to them... doing this way hides knowledge of how we inspect that state
// ref: https://stackoverflow.com/a/48668350
export function isDisonnected$(store$: Store<AppState>): Observable<SignalRData> {
  return store$.pipe(
    select(selectSignalRState),
    filter((state: SignalRData) => state.connectionState === HubConnectionState.Disconnected),
    distinctUntilChanged(),
  );
}

export function ensureIsConnectedSelector$(store$: Store<AppState>, maxWait = 20000): Observable<unknown> {
  return store$.pipe(
    select(selectSignalRState),
    filter((s) => s.connectionState !== HubConnectionState.Disconnected),
    distinctUntilChanged((a, b) => a.connectionState === b.connectionState),
    timeout({ first: maxWait }),
    first((s) => s.connectionState === HubConnectionState.Connected),
  );
}

// Commented because ensureIsConnectedSelector$ can fulfill the same purpose
//
// export function isConnected$(store$: Store<AppState>, _maxWait?: number): Observable<SignalRData> {
//   return store$.pipe(
//     select(selectSignalRState),
//     filter((state: SignalRData) => state.connectionState === HubConnectionState.Connected),
//     distinctUntilChanged(),
//   );
// }
